import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\AddUserAvatarController::__invoke
* @see app/Http/Controllers/User/AddUserAvatarController.php
* @route '/api/user/{user}/avatar'
*/
const AddUserAvatarController = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddUserAvatarController.url(args, options),
    method: 'post',
})

AddUserAvatarController.definition = {
    methods: ["post"],
    url: '/api/user/{user}/avatar',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\User\AddUserAvatarController::__invoke
* @see app/Http/Controllers/User/AddUserAvatarController.php
* @route '/api/user/{user}/avatar'
*/
AddUserAvatarController.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return AddUserAvatarController.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\AddUserAvatarController::__invoke
* @see app/Http/Controllers/User/AddUserAvatarController.php
* @route '/api/user/{user}/avatar'
*/
AddUserAvatarController.post = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddUserAvatarController.url(args, options),
    method: 'post',
})

export default AddUserAvatarController